import { keyframes } from 'twind/css'

export const rippleAnimation = keyframes({
  from: {
    opacity: 0.8,
    transform: 'scale3d(1, 1, 1)',
  },
  to: {
    opacity: 0,
    transform: 'scale3d(1.2, 1.2, 1)',
  },
})

export const bounceAnimation = keyframes({
  '0%': {
    transform: 'scale(0.99)',
  },
  '100%': {
    transform: 'scale(1)',
  },
})
